import getApi from '../../api'
import { TagMutationPayload, TagType } from '../../model/Tag'

export const createTag = (tag: TagMutationPayload) => getApi().post<TagType>(`/tags`, tag)
